import { Relationship } from "csi/def/Relationship";
import locale from "csi/locale";
import { PATH_PARENT } from "csi/reflection/reflectionConstants";
import declare from "dojo/_base/declare";
import CalendarActivities from "./CalendarActivities";

const _CalendarHierarchyActivities = declare(CalendarActivities, {
	/**
	 * @override
	 * Customize hierarchy relationship names based on path hint to parent class
	 */
	onQueryRelationshipName(rel: Relationship): string {
		const targetType = rel.getTargetType();

		if (targetType === "Calendar") {
			const parentType = rel.pathHintsContext.getTarget(targetType, PATH_PARENT);
			return locale.type(parentType);
		}

		return "";
	},
});

export = _CalendarHierarchyActivities;